import _isUndefined from 'lodash/isUndefined'
import React from 'react'
import PropTypes from 'prop-types'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'

const BLOCK_CLASSNAME = 'button-toggle'

function getClassName (elementName, options = {}) {
  const { checked, round, small } = options
  const blockElement = elementName ? `${BLOCK_CLASSNAME}__${elementName}` : BLOCK_CLASSNAME
  const classNames = [blockElement]
  if (small) classNames.push(`${blockElement}--small`)
  if (round) classNames.push(`${blockElement}--round`)
  if (!_isUndefined(checked)) {
    classNames.push(checked ? `${blockElement}--state-on` : `${blockElement}--state-off`)
  }
  return classNames.join(' ')
}

class ButtonToggle extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  onClick = () => {
    const {
      onChange,
      setEventDefault,
      ga4EventData,
    } = this.props

    onChange()

    // GA4 events
    if (ga4EventData) {
      setEventDefault(ga4EventData)
    }
  }

  render () {
    const { props, onClick } = this
    const {
      checked,
      labelTextOn,
      labelTextOff,
      round,
      small,
      staticText,
      showLabel,
    } = props

    const renderLabelTextOn = labelTextOn || staticText.getIn(['data', 'labelOn'])
    const renderLabelTextOff = labelTextOff || staticText.getIn(['data', 'labelOff'])
    return (
      <div className={getClassName(null, { small })}>
        {/* eslint-disable-next-line jsx-a11y/label-has-for */}
        <label className={getClassName('label')}>
          {showLabel && (checked ? renderLabelTextOn : renderLabelTextOff)}
          <input
            className={getClassName('checkbox')}
            type="checkbox"
            checked={checked}
            onChange={onClick}
          />
          <span className={getClassName('toggle-switch')}>
            <span className={getClassName('slider', { checked, round })} />
          </span>
        </label>
      </div>
    )
  }
}

ButtonToggle.defaultProps = {
  onChange: undefined,
  checked: false,
  round: false,
  small: false,
  ga4EventData: null,
}

ButtonToggle.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  showLabel: PropTypes.bool,
  labelTextOn: PropTypes.string,
  labelTextOff: PropTypes.string,
  round: PropTypes.bool,
  small: PropTypes.bool,
  setEventDefault: PropTypes.func,
  ga4EventData: PropTypes.object,
}

export default connectRedux(
  (state) => ({
    staticText: state.staticText.getIn(['data', 'buttonToggle']),
    featureTracking: state.featureTracking,
    userStore: state.user,
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      setEventDefault: actions.eventTracking.setEventDefault,
    }
  },
)(ButtonToggle)
